
var Model = require("../types/Model.js");
var par = require("par");

/**
 * This is the main model for desktop applications. It holds all the state necessary for the app.
 * @type {Model}
 */
module.exports = Model({
	name: "simplified",
	init: init,
	listeners: listeners,
	triggers: triggers,

	set_page: set_page,
});

function init() {
	/*
	 * This is the initial state. This is what things look like initially
	 */
	this.push({
		loading: false,
		settings: {},
		banners: [],
		header: {}, // The header contents
		availability: {}, // The availability of all the people getting tracked
		page: "home", // What the main page is currently showing
		config: this.config, // The config passed in during creation
		localization: {}, // The current localization file
		personal: {}, // State of personal settings
		offline: false, // Whether the machine is offline
		options: {}, // Options for the trunk
		bracelet: {}, // The state of the connected bracelet
		activity: {}, // the patients own activity
		bloodsugar: {}, //the patients blood sugar
		bloodpressure: {}, //the patients blood pressure
		bloodoxygen: {}, //the patients blood oxygen
		bodytemperature: {}, //the patients body temperature
		weight: {}, //the patients weight
		reminders: null, // The state of the reminders
		toast: null, // The state of the toast notification
		orientation: "",
		size: {},
		screenlocker: false,
		keepawake: false,
		screensaver: false,
		newreading: {},
		comment: {},
		workflowaction: false,
		feedbackmodal: false,
		keyboard: false,
		orggroup: null,
		pausescreen: false,
		fileviewer: {},
		pendingactions: [],
		status: null,
		workflowdefinition: [],
		resources: {},
		devices: [],
		metawearauto: false,
		license: false,
		privacypolicy: false,
		aboutbox: {},
		reading: {},
		people: {}
	});

	this.emit("orientationlocker:trigger:lock", {
		orientation: "portrait"
	});

	this.emit("keepawake:trigger:lock");
	this.emit("screenlocker:trigger:lock");
}

/**
 * Sets the current page to be displayed
 * @param {String} page One of "calling", "contacts", "messaging"
 */
function set_page(page) {
	this.extend({
		page: page
	});
}

function listeners() {
	var sound = make_sound_trigger.bind(this);

	return {
		"banner:updated": makeExtender("banners"),
		"online:updated": handle_online_update,
		"atouchawaysettings:updated": makeExtender("settings"),
		"localization:updated": handle_localization_update,
		"availability:updated": makeExtender("availability"),
		"personal:updated": makeExtender("personal"),
		"screenhider:updated": makeExtender("hide"),
		"screensaver:updated": makeExtender("screensaver"),
		"options:updated": makeExtender("options"),
		"bracelet:updated": makeExtender("bracelet"),
		"bloodoxygen:updated": makeExtender("bloodoxygen"),
		"bodytemperature:updated": makeExtender("bodytemperature"),
		"weight:updated": makeExtender("weight"),
		"bloodpressure:updated": makeExtender("bloodpressure"),
		"bloodsugar:updated": makeExtender("bloodsugar"),
		"activity:updated": makeExtender("activity"),
		"overview:updated": makeExtender("overview"),
		"newreading:updated": makeExtender("newreading"),
		"comment:updated": makeExtender("comment"),
		"activereminder:updated": makeExtender("reminders"),
		"activereminder:active": sound("alert"),
		"keyboard:updated": makeExtender("keyboard"),
		"pausescreen:updated": makeExtender("pausescreen"),
		"buzz:state:calling": make_sound_trigger("outgoing", true),
		"buzz:state:receiving": make_sound_trigger("incoming", true),
		"meetings:start": make_sound_trigger("incoming", true),
		"meetings:stop": stop_sounds,
		"toast:updated": makeExtender("toast"),
		"screenorientation:updated": makeExtender("screenorientation"),
		"orientation:updated": Model.makeExtender("orientation"),
		"size:updated": Model.makeExtender("size"),
		"toosmall:updated": Model.makeExtender("toosmall"),
		"about:updated": Model.makeExtender("aboutbox"),
		"about:unlocked": par(set_page, "setting"),
		"about:settings": par(set_page, "setting"),
		"about:exit": par(set_page, "home"),
		"screenlocker:updated": Model.makeExtender("screenlocker"),
		"keepawake:updated": Model.makeExtender("keepawake"),
		"feedbackmodal:updated": Model.makeExtender("feedbackmodal"),
		"activeworkflowaction:updated": Model.makeExtender("workflowaction"),
		"activeworkflowaction:viewing": sound("alert"),
		"orggroup:updated": makeExtender("orggroup"),
		"workflowactionpending:updated": makeExtender("pendingactions"),
		"workflowdefinitions:updated": makeExtender("workflowdefinitions"),
		"metawearscheduler:updated": makeExtender("metawearauto"),
		"license:updated": makeExtender("license"),
		"privacypolicy:updated": makeExtender("privacypolicy"),
		"reading:updated": makeExtender("reading"),
		"people:updated": makeExtender("people")
	};
}

function triggers() {
	return {
		"page": handle_trigger_page,
	};
}

function make_sound_trigger(sound, loop) {
	return function () {
		this.emit("sounds:trigger:play", {
			sound: sound,
			loop: loop
		});
	}.bind(this);
}

function stop_sounds() {
	this.emit("sounds:trigger:stop");
}

/**
 * Handles trigger for changing the page
 * @param  {Object} data Data containing the `page` to switch to.
 */
function handle_trigger_page(data) {
	var page = data.page;
	this.set_page(page);
	this.emit("usermetrics:trigger:track", `navigate to ${page}`);
}

function handle_online_update(data) {
	var status = !data; // offline status is opposite of online status.
	this.extend({
		offline: status
	});
}

function handle_localization_update(localization) {
	this.extend({
		localization: localization.localization
	});
}

function makeExtender(name) {
	return function (data) {
		var update = {};
		update[name] = data;
		this.extend(update);
	};
}
